import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Asset, Event } from '@app/core/interfaces';
import { EventsService } from '@app/services/events.service';
import { WebSocketService } from '@app/services/websocket.service';

@Component({
  selector: 'app-screensaver',
  templateUrl: './screensaver.component.html',
  styleUrls: ['./screensaver.component.scss'],
})
export class ScreensaverComponent implements OnInit, OnDestroy {
  interloper: Asset | null = null;

  constructor(
    public socketService: WebSocketService,
    public eventService: EventsService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.interloper = null;
  }

  ngOnDestroy() {
    this.interloper = null;
  }

  dismissBio() {
    this.interloper = null;
  }
}
